konnyScript(function($){
    var gifSlide = new Swiper('#e_gif_swiper_slide1',{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            //effect:'fade',
            speed :0,
            autoplay:{
                delay:1500,
                disableOnInteraction: false,
            },
    });
    var gifSlide = new Swiper('#e_gif_swiper_slide2',{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            //effect:'fade',
            speed :0,
            autoplay:{
                delay:1500,
                disableOnInteraction: false,
            },
    });
});